import React, { Fragment } from "react";
import TopBarProgress from "react-topbar-progress-indicator";
import { Grid, Hourglass, Ripple } from "react-spinners-css";

TopBarProgress.config({
  barColors: {
    0: "green",
    "1.0": "green",
  },
  shadowBlur: 5,
});

export function TopBarLoader() {
  return (
    <React.Fragment>
      <TopBarProgress />
    </React.Fragment>
  );
}

export function PageLoader() {
  return (
    <Fragment>
      <div className={"w-full h-full mt-10 flex justify-center items-center"}>
        <Ripple color="#dba309" size={100} />
      </div>
    </Fragment>
  );
}
export function HourglassLoader() {
  return (
    <Fragment>
      <div
        className="w-full"
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: "60vh",
        }}
      >
        <Hourglass size={50} />
      </div>
    </Fragment>
  );
}
